import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(client)/transactions')({
  beforeLoad: ({ location }) => {
    if (
      location.pathname === '/transactions' ||
      location.pathname === '/transactions/'
    ) {
      throw redirect({ to: '/transactions/incoming' });
    }
  },
});
